import { FileTypeCopySink } from './file-type.copysink';
import { IModel } from 'app/model/base/annotation';
import { Metamodel } from 'app/model/base/model';
import { AzureBlobDataset } from 'app/model/dataset/azure-blob.dataset';

@Metamodel.model({
    name: 'BlobSink',
    display: [],
    referable: true,
    tags: { datasetModel: Metamodel.modelFor(AzureBlobDataset) }
})
export class BlobSink extends FileTypeCopySink {
    public static readonly MODEL: IModel;
}
